/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class DecoratorAPI
 * @hideconstructor
 * @classdesc implementation of the DecoratorAPI interface.
 */
define([], () => {
	class DecoratorAPI {

		/**
		 * @function DecoratorAPI#decorateItem
		 * @description Decorate an item in the visualization. After setting the decoration, {@link DecoratorAPI#renderDecorations} must be called to update the rendering.
		 * The supported decorations are listed in Visualization.DECORATIONS.
		 * @public
		 *
		 * @param {Number} itemIndex
		 * @param {String} decoration
		 * @param {Object} value
		 *
		 * @todo: is there a better name than "item" ?
		 */
		decorateItem(/* itemIndex, decoration, value */) { }


		/**
		 * @function DecoratorAPI#decoratePoint
		 * @description Decorate an datapoint in the visualization. After setting the decoration, {@link DecoratorAPI#renderDecorations} must be called to update the rendering.
		 * The supported decorations are listed in Visualization.DECORATIONS.
		 * @public
		 *
		 * @param {Number} rowIndex
		 * @param {String} decoration
		 * @param {Object} value
		 *
		 */
		decoratePoint(/* rowIndex, decoration, value */) { }


		/**
		 * @function DecoratorAPI#decorate
		 * @description Decorate the visualization. After setting the decoration, {@link DecoratorAPI#renderDecorations} must be called to update the rendering.
		 * The supported decorations are listed in Visualization.DECORATIONS.
		 * @public
		 *
		 * @param {String} decoration
		 * @param {Object} value
		 *
		 */
		decorate(/* decoration, value */) { }



		/**
		 * @function DecoratorAPI#clearAllItemDecoration
		 * @description Clear all the decorations associcated with all items. After setting the decoration, {@link DecoratorAPI#renderDecorations} must be called to update the rendering.
		 * The supported decorations are listed in Visualization.DECORATIONS.
		 * @public
		 *
		 * @param {String} decoration
		 *
		 */
		clearAllItemDecoration(/* decoration */) { }

		/**
		 * @function DecoratorAPI#renderDecorations
		 * @description renderDecorations - render the existing decoration that are set in the visualization.
		 * @public
		 */
		renderDecorations() { }
	}

	return DecoratorAPI;
});
